module.exports = __webpack_public_path__ + "4e747209bf2435004d18d96611527cd8.svg";